export const animatePulse = (loading: boolean): string =>
    loading ? "animate-pulse" : ""